import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    backgroundColor: theme.palette.background.default,
    border: 'none',
    boxShadow: 'none',
    borderRadius: '30px',
    height: '100%',
    '& .MuiCardActionArea-root': {
      height: '100%'
    },
    '&:active': {
      backgroundColor: 'rgba(0,0,0,0.05)'
    },
    '&:hover .MuiCardContent-root .MuiCardHeader-root': {
      color: theme.palette.grey[500]
    }
  },
  cardActionArea: {
    padding: '10px',
    '&:hover': {
      borderRadius: '30px',
      backgroundColor: 'transparent',
      boxShadow: '0 4px 16 #ECECEC inset'
    },
    '&:hover .MuiCardActionArea-focusHighlight': {
      opacity: 0
    }
  },
  img: {
    width: '100%',
    objectFit: 'cover',
    aspectRatio: '16/9',
    borderRadius: '20px',
    marginBottom: theme.spacing(1)
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    gap: theme.spacing(1),
    '& .MuiCardHeader-root': {
      padding: 0
    }
  },
  title: {
    marginTop: theme.spacing(1),
    '& .MuiTypography-root': {
      fontWeight: 500,
      display: '-webkit-box',
      lineHeight: '1.2em',
      minHeight: '2.4em',
      boxOrient: 'vertical',
      lineClamp: 2,
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  moreRecentText: {
    display: '-webkit-box',
    lineHeight: '1.2em',
    minHeight: '2.4em',
    boxOrient: 'vertical',
    lineClamp: 2,
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxLines: 2
  },
  actions: {
    alignSelf: 'flex-end',
    '& .MuiButton-root': {
      borderRadius: theme.spacing(2)
    },
    '& .MuiButtonBase-root .MuiButton-label .MuiTypography-body2': {
      fontSize: '1rem'
    },
    '&.MuiCardActions-root': {
      padding: 0
    },
    '&:hover': {
      color: theme.palette.background.paper
    },
    '&:active': {
      backgroundColor: 'transparent'
    }
  },
  actionsButton: {
    padding: '6px 10px',
    backgroundColor: 'none',
    color: theme.palette.primary.dark,
    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: 'transparent'
    },
    '&:active': {
      backgroundColor: 'transparent'
    }
  }
}))
